import React, { Suspense, lazy } from 'react';
import { OfferBanner } from './components/OfferBanner';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { PainPoints } from './components/PainPoints';
const ProductOverview = lazy(() => import('./components/ProductOverview').then(m => ({
  default: m.ProductOverview
})));
const TomoDetails = lazy(() => import('./components/TomoDetails').then(m => ({
  default: m.TomoDetails
})));
const Bonuses = lazy(() => import('./components/Bonuses').then(m => ({
  default: m.Bonuses
})));
const CountdownPricing = lazy(() => import('./components/CountdownPricing').then(m => ({
  default: m.CountdownPricing
})));
const KitScale = lazy(() => import('./components/KitScale').then(m => ({
  default: m.KitScale
})));
const MoreTestimonials = lazy(() => import('./components/MoreTestimonials').then(m => ({
  default: m.MoreTestimonials
})));
const Guarantee = lazy(() => import('./components/Guarantee').then(m => ({
  default: m.Guarantee
})));
const FAQ = lazy(() => import('./components/FAQ').then(m => ({
  default: m.FAQ
})));
const CostComparison = lazy(() => import('./components/CostComparison').then(m => ({
  default: m.CostComparison
})));
const FinalCTA = lazy(() => import('./components/FinalCTA').then(m => ({
  default: m.FinalCTA
})));
const SocialProofPopup = lazy(() => import('./components/SocialProofPopup').then(m => ({
  default: m.SocialProofPopup
})));
export function App() {
  return <div className="min-h-screen bg-brand-darker font-sans text-brand-muted selection:bg-brand-terracotta selection:text-white" data-id="element-0">
      <OfferBanner data-id="element-1" />
      <Suspense fallback={<div className="min-h-screen" data-id="element-3" />} data-id="element-2">
        <SocialProofPopup data-id="element-4" />
      </Suspense>
      <main data-id="element-5">
        <Hero data-id="element-6" />
        <SocialProof data-id="element-7" />
        <PainPoints data-id="element-8" />
        <Suspense fallback={<div className="min-h-[50vh] " data-id="element-10" />} data-id="element-9">
          <ProductOverview data-id="element-11" />
          <TomoDetails data-id="element-12" />
          <Bonuses data-id="element-13" />
          <CountdownPricing data-id="element-14" />
          <KitScale data-id="element-15" />
          <MoreTestimonials data-id="element-16" />
          <Guarantee data-id="element-17" />
          <FAQ data-id="element-18" />
          <CostComparison data-id="element-19" />
          <FinalCTA data-id="element-20" />
        </Suspense>
      </main>
    </div>;
}